import React from 'react';

interface ChatLauncherProps {
  open: boolean;
  onToggle(): void;
}

export default function ChatLauncher({ open, onToggle }: ChatLauncherProps): JSX.Element {
  return (
    <button
      aria-label={open ? 'Hide support chat' : 'Open support chat'}
      className="widget-launcher"
      onClick={onToggle}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        <path d="M9 9h.01" />
        <path d="M15 9h.01" />
        <path d="M9 15c.5.5 1.5 1 2.5 1s2-.5 2.5-1" />
      </svg>
      <span className="text-sm font-semibold">Support</span>
    </button>
  );
}
